import axios from '@/utils/http';

export default () => {
  return axios
    .get('/user/current_conversations')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
